import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap'
import s from './InstallProposalModal.scss'
import { useState } from 'react'
import { makePostRequest } from 'utils/api'
import { useLoading } from 'hooks'
import { toTemplates } from 'utils/serializers'
import { HtmlProposalLibrary } from 'components/common/HtmlProposalLibrary'

const InstallProposalModal = ({
  setIsInstallHtmlProposalModalVisible,
  isInstallHtmlProposalModalVisible,
  predesignedTemplates,
  setTemplates,
  templates
}) => {
  const [leftSelectedIndex, setLeftSelectedIndex] = useState('')
  const [middleSelectedIndex, setMiddleSelectedIndex] = useState('')
  const [templateOptions, setTemplateOptions] = useState([])
  const [, withLoadingLocks] = useLoading()

  const closeModal = () => {
    setIsInstallHtmlProposalModalVisible(false)
  }

  const installTemplate = async () => {
    const response = await withLoadingLocks(
      makePostRequest('/v1/proposaltemplates/presignedtemplate', {
        id: predesignedTemplates[leftSelectedIndex].id,
        thumbnailUrl: templateOptions[middleSelectedIndex].coverUrl
      })
    )
    setTemplates([...templates, toTemplates([response])[0]])
    closeModal()
  }

  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        isOpen={isInstallHtmlProposalModalVisible}
        toggle={closeModal}
        size="xl"
        className={s.modal}
      >
        <ModalHeader toggle={closeModal} className={s.modalHeader}>
          Install Predefined Proposal Template
        </ModalHeader>
        <ModalBody className={s.modalBody}>
          <HtmlProposalLibrary
            predesignedTemplates={predesignedTemplates}
            setLeftSelectedIndexCb={setLeftSelectedIndex}
            setMiddleSelectedIndexCb={setMiddleSelectedIndex}
            setTemplateOptionsCb={setTemplateOptions}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={closeModal}>
            Cancel
          </Button>
          <Button
            className={s.saveBtn}
            onClick={installTemplate}
            disabled={middleSelectedIndex === ''}
          >
            Install Template
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default InstallProposalModal
